<div class="help-menu-container">
  <!-- Help button: opens modal for Planners/PMs, opens ServiceNow directly for MAT Coordinators -->
  <button
    (click)="onHelpClick()"
    class="nav-item help-nav-item"
    type="button"
    aria-label="Help"
    [title]="isMatCoordinator ? 'Create Service Now Ticket' : 'Help & Support'"
    data-test-hook="HL-/help">
    <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M12 16v-4"></path>
      <path d="M12 8h.01"></path>
    </svg>
    <span>Help</span>
  </button>

  <!-- Help Modal (Planners/PMs only) -->
  <app-help-modal
    *ngIf="showHelpModal"
    [adminName]="adminName"
    [adminEmail]="adminEmail"
    (close)="closeHelpModal()">
  </app-help-modal>
</div>
